import 'Components/modal/modal-remote';
import 'Components/modal/modal-address';

$(function() {
    $('.js-remove-address').on('click', function(event) {
        event.preventDefault()

        const $el = $(this)
        const $data = $el.data()
        const $actionsHolder = $el.closest('.js-address-actions')

        Eshop.confirm($data.confirm, {
            denyButtonText: $data.denyText,
            confirmButtonText: $data.confirmText
        }, () => {
            $el.prop('disabled', true).addClass('is-loading')
            $actionsHolder.addClass('is-loading')
            window.location.href = $el.data('href') || $el.attr('href')
        })
    });
});